/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync>): BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync {
        let obj = Object.assign(new BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync(), model);
        BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync>): BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync {
        if (!model) return null;
        return BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync.newInstance(<BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync) {
        if (!obj) return;

        models.BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of service account ID(s) to sync threats/ vulnerability to GraphDB.
     */
    service_account_ids: Array<string>;

    /**
     * Whether to perform a full sync or incremental sync. Full sync will sync all the data whereas incremental sync will only sync the data that has been created/updated since the last sync time.
     */
    full_sync: boolean;

    /**
     * If set true, it sync threat summaries to graphDB
     */
    sync_threat_summary: boolean;

    /**
     * If set true, it sync vulnerability summaries to graphDB
     */
    sync_vulnerability_summary: boolean;

}
